// fetchTest.js
import { supabase } from "./supabaseClient";

/**
 * Get the list of question IDs from a test
 */
export async function getTestQuestions(testId) {
  const { data, error } = await supabase
    .from("tests")
    .select("questions")
    .eq("id", testId)
    .single();

  if (error) return { success: false, msg: error.message };
  return { success: true, questionIds: data.questions };
}

/**
 * Get all resource rows for a given question ID
 */
export async function getQuestionResources(questionId) {
  const { data, error } = await supabase
    .from("resources")
    .select("*")
    .eq("q_id", questionId)
    .order("ind", { ascending: true });

  if (error) return { success: false, msg: error.message };
  return { success: true, rows: data };
}



/**
 * Full pipeline: testId → list of question objects ready for display
 */
export async function loadTestQuestions(testId) {
  // 1. Get question IDs from test
  const testResult = await getTestQuestions(testId);
  if (!testResult.success) return { success: false, msg: testResult.msg };

  const questionIds = testResult.questionIds;
  const questions = [];

  // 2. Fetch resources for each question
  for (let i = 0; i < questionIds.length; i++) {
    const resResult = await getQuestionResources(questionIds[i]);
    if (!resResult.success) {
      return { success: false, msg: `Failed to load question ${i + 1}: ${resResult.msg}` };
    }

    const question = buildQuestionFromRows(resResult.rows, i + 1);
    if (question) questions.push(question);
  }

  return { success: true, questions };
}

/**
 * Convert resource rows into a question object
 * rows: [{ id, res, media, ind, time, test_id, owner_id, created_at }, ...]
 * returns: { ind, id, items: [...], time }
 */
export function buildQuestionFromRows(rows, questionIndex) {
  if (!rows || rows.length === 0) return null;

  const sorted = [...rows].sort((a, b) => Number(a.ind) - Number(b.ind));

  const items = sorted.map(row => ({
    media: row.media,
    res: row.res,
    ind: Number(row.ind),
  }));

  return {
    ind: questionIndex,
    id: rows[0].q_id,
    items,
    time: rows[0].time ?? null,
  };
}


export async function getTestsByOwner(ownerId) {
  const { data, error } = await supabase
    .from('tests')
    .select('*')
    .eq('owner_id', ownerId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  console.log("owner test", ownerId,data);
  return data;
}